import React from 'react';
import Grid from 'src/app/atoms/Layout/Grid/Grid';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import Typography, { TypographyProps } from 'src/app/atoms/Typography/Typography';
import CheckItemTextList, { CheckItemTextListProps } from '../CheckItemTextList/CheckItemTextList';
import { cssVar } from 'src/app/styles/helper';
import { ColorModeBorderPropKeys } from 'styles/colors';

export interface ListGroupItemProps {
  heading: TypographyProps;
  checkItemTextListProps: CheckItemTextListProps;
  topRightElement?: React.ReactNode;
  borderColor?: ColorModeBorderPropKeys;
}

const ListGroupItem = ({
  heading,
  checkItemTextListProps,
  topRightElement,
  borderColor = 'border-brand-alt',
}: ListGroupItemProps): JSX.Element => {
  const borderStyle = `1px solid ${cssVar(borderColor)}`;

  return (
    <Grid
      totalColumns={1}
      border={borderStyle}
      borderRadius='radius-xl'
    >
      <Stack
        direction='row'
        justify='space-between'
        align='center'
        padding='spacing-lg'
        borderBottom={borderStyle}
      >
        <Typography {...heading} />
        {topRightElement}
      </Stack>
      <Stack padding='spacing-lg'>
        <CheckItemTextList
          padding='spacing-none'
          {...checkItemTextListProps}
        />
      </Stack>
    </Grid>
  );
};

export default ListGroupItem;
